import { render, staticRenderFns } from "./StudentEditTabAttributes.vue?vue&type=template&id=a4bb02d4&"
import script from "./StudentEditTabAttributes.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports